import { makeSx } from '../../theme/_utils'
import { defaultPalette } from '../../theme/idsTheme'

export default makeSx({
    MessageStateText: {
        color: defaultPalette.typography.grey,
        fontSize: '1.1rem',
        width: '70%',
    },
    MessageStateContent: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        marginBottom: '48px',
        marginTop: '16px',
    },
    ErrorStateText: {
        color: defaultPalette.error.main,
        fontSize: '1.1rem',
        width: '70%',
    },
})
